import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermosDeUso.css';

const TermosDeUso: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="termos-page">
      {/* Header */}
      <header className="termos-header">
        <div className="termos-header-content">
          <div className="termos-logo" onClick={() => navigate('/')}>
            <img src="/logo_transp.png" alt="ContratoSeguro" />
          </div>
          <button onClick={() => navigate('/')} className="btn-back">
            Voltar para o início
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="termos-main">
        <div className="termos-container">
          <div className="termos-content">
            <h1>TERMOS DE USO — CONTRATOSEGURO</h1>
            <p className="termos-updated">Última atualização: 6 de fevereiro de 2026</p>

            <p className="termos-intro">
              Bem-vindo ao <strong>ContratoSeguro</strong>. Ao acessar ou usar nossa plataforma,
              você concorda com estes Termos de Uso. Leia atentamente antes de prosseguir.
            </p>

            <section className="termos-section">
              <h2>1. Sobre o ContratoSeguro</h2>
              <p>
                O <strong>ContratoSeguro</strong> é uma plataforma digital que oferece análise
                automatizada de contratos de locação usando tecnologia de Inteligência
                Artificial. Nosso objetivo é ajudar locadores e locatários a entenderem melhor os contratos
                antes de assinarem.
              </p>
              <p className="termos-important">
                <strong>Importante:</strong> O ContratoSeguro <strong>NÃO</strong> oferece consultoria
                jurídica, não substitui um advogado e não valida juridicamente contratos. Nossa análise
                é educativa e informativa.
              </p>
            </section>

            <section className="termos-section">
              <h2>2. Quem pode usar</h2>
              <ul>
                <li>Pessoas maiores de 18 anos.</li>
                <li>Residentes no Brasil.</li>
                <li>Usuários que concordam com estes Termos e com nossa Política de Privacidade.</li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>3. Cadastro e conta</h2>
              <p>Para usar o ContratoSeguro, você deve:</p>
              <ul>
                <li>Criar uma conta com informações verdadeiras e atualizadas.</li>
                <li>Manter a segurança da sua senha.</li>
                <li>Não compartilhar sua conta com terceiros.</li>
                <li>Notificar-nos imediatamente em caso de uso não autorizado.</li>
              </ul>
              <p>
                Você é responsável por todas as atividades realizadas em sua conta.
              </p>
              <p>
                Ao enviar contratos que contenham dados pessoais de terceiros (como locadores,
                locatários, fiadores ou testemunhas), você declara ter autorização ou outra base
                legal válida para compartilhar essas informações e permitir seu tratamento pelo
                ContratoSeguro.
              </p>
            </section>

            <section className="termos-section">
              <h2>4. Como funciona o serviço</h2>
              <p>Ao usar o ContratoSeguro, você:</p>
              <ul>
                <li>Faz upload de um contrato de locação em formato PDF.</li>
                <li>
                  Nosso sistema extrai o texto do documento e envia para uma API de Inteligência
                  Artificial (OpenAI GPT).
                </li>
                <li>
                  A plataforma identifica e registra os dados das partes do contrato (ex.: nome,
                  CPF/CNPJ, endereço, e-mail, telefone de locadores, locatários, fiadores e
                  testemunhas) para gerar resumos, alertas e notificações.
                </li>
                <li>
                  A IA analisa o contrato com base em critérios da <strong>Lei do Inquilinato
                  (Lei nº 8.245/1991)</strong> e boas práticas contratuais.
                </li>
                <li>
                  Você recebe um resumo com: identificação de cláusulas importantes, alertas sobre
                  riscos e explicações em linguagem simples.
                </li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>5. O que você PODE fazer</h2>
              <ul>
                <li>Fazer upload de contratos de locação residencial para análise.</li>
                <li>Visualizar e baixar os resultados da análise.</li>
                <li>Usar a plataforma para fins pessoais e educativos.</li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>6. O que você NÃO PODE fazer</h2>
              <p>É expressamente proibido:</p>
              <ul>
                <li>Fazer upload de documentos falsos, ilegais ou que violem direitos de terceiros.</li>
                <li>Usar a plataforma para fins comerciais sem autorização prévia.</li>
                <li>Tentar hackear, sobrecarregar ou prejudicar o funcionamento do sistema.</li>
                <li>Copiar, redistribuir ou revender o conteúdo gerado pela plataforma sem autorização.</li>
                <li>Usar bots, scripts ou ferramentas automáticas para acessar o serviço.</li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>7. Seus documentos e privacidade</h2>
              <ul>
                <li>
                  <strong>Armazenamento:</strong> Os contratos enviados são armazenados de forma
                  criptografada em nossos servidores.
                </li>
                <li>
                  <strong>Uso:</strong> Seus documentos são usados apenas para gerar a análise
                  solicitada.
                </li>
                <li>
                  <strong>Dados das partes:</strong> Extraímos e armazenamos, de forma estruturada e
                  segura, informações das partes do contrato (ex.: nome, CPF/CNPJ, endereço,
                  e-mail, telefone e dados de fiadores/testemunhas) para entregar resumos,
                  histórico, obrigações e notificações vinculadas ao documento.
                </li>
                <li>
                  <strong>Compartilhamento com IA:</strong> O texto extraído do PDF é enviado para
                  a API da OpenAI para análise. A OpenAI não armazena ou treina modelos com seus dados
                  (conforme política de uso corporativo da API).
                </li>
                <li>
                  <strong>Exclusão:</strong> Você pode solicitar a exclusão dos seus documentos a
                  qualquer momento através do e-mail: <a href="mailto:privacidade@contratoseguro.com.br">privacidade@contratoseguro.com.br</a>
                </li>
              </ul>
              <p>
                Para mais detalhes, consulte nossa <a href="/politica-de-privacidade">Política de Privacidade</a>.
              </p>
            </section>

            <section className="termos-section">
              <h2>8. Limitações do serviço</h2>
              <p>
                <strong>O ContratoSeguro é uma ferramenta de apoio educativo.</strong> Isso significa que:
              </p>
              <ul>
                <li>
                  <strong>Não somos advogados:</strong> A análise gerada não constitui aconselhamento
                  jurídico.
                </li>
                <li>
                  <strong>Não garantimos precisão absoluta:</strong> A IA pode cometer erros ou não
                  identificar todas as cláusulas problemáticas.
                </li>
                <li>
                  <strong>Você é responsável:</strong> A decisão final de assinar ou não um contrato
                  é sempre sua. Recomendamos consultar um advogado antes de assinar documentos importantes.
                </li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>9. Planos e pagamentos</h2>
              <ul>
                <li><strong>Plano Gratuito:</strong> Permite até 5 análises por dia.</li>
                <li>
                  <strong>Planos Pagos:</strong> Oferecem análises ilimitadas e funcionalidades extras
                  (quando disponíveis).
                </li>
                <li>
                  <strong>Cancelamento:</strong> Você pode cancelar sua assinatura a qualquer momento.
                  Não oferecemos reembolso proporcional.
                </li>
                <li>
                  <strong>Alterações de preço:</strong> Podemos alterar os preços dos planos com aviso
                  prévio de 30 dias.
                </li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>10. Propriedade intelectual</h2>
              <ul>
                <li>
                  Todo o conteúdo da plataforma (textos, design, logotipos, código) é de propriedade
                  do <strong>ContratoSeguro</strong> ou de seus licenciadores.
                </li>
                <li>
                  Você mantém todos os direitos sobre os contratos que envia.
                </li>
                <li>
                  O resultado da análise gerada é de sua propriedade, mas você não pode redistribuí-lo
                  comercialmente sem autorização.
                </li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>11. Isenção de responsabilidade</h2>
              <p>
                O ContratoSeguro é fornecido <strong>"como está"</strong>. Não nos responsabilizamos por:
              </p>
              <ul>
                <li>Decisões tomadas com base nas análises geradas.</li>
                <li>Perdas financeiras ou danos decorrentes do uso da plataforma.</li>
                <li>Indisponibilidade temporária do serviço.</li>
                <li>Erros ou imprecisões nas análises geradas pela IA.</li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>12. Modificações nos Termos</h2>
              <p>
                Podemos atualizar estes Termos de Uso periodicamente. Quando fizermos alterações
                significativas, notificaremos você por e-mail ou através de um aviso na plataforma.
              </p>
              <p>
                O uso contínuo do ContratoSeguro após as alterações significa que você aceita os novos termos.
              </p>
            </section>

            <section className="termos-section">
              <h2>13. Cancelamento e suspensão</h2>
              <p>Podemos suspender ou encerrar sua conta se:</p>
              <ul>
                <li>Você violar estes Termos de Uso.</li>
                <li>Detectarmos uso fraudulento ou abusivo.</li>
                <li>For necessário por questões legais ou de segurança.</li>
              </ul>
            </section>

            <section className="termos-section">
              <h2>14. Lei aplicável e foro</h2>
              <p>
                Estes Termos são regidos pelas leis do Brasil. Qualquer disputa será resolvida no
                foro da comarca de [cidade], com exclusão de qualquer outro.
              </p>
            </section>

            <section className="termos-section">
              <h2>15. Contato</h2>
              <p>Se você tiver dúvidas sobre estes Termos, entre em contato:</p>
              <ul>
                <li><strong>E-mail geral:</strong> <a href="mailto:suporte@contratoseguro.com.br">suporte@contratoseguro.com.br</a></li>
                <li><strong>E-mail LGPD/Privacidade:</strong> <a href="mailto:privacidade@contratoseguro.com.br">privacidade@contratoseguro.com.br</a></li>
              </ul>
            </section>

            <div className="termos-acceptance">
              <p>
                <strong>Ao usar o ContratoSeguro, você declara que leu, compreendeu e concorda com
                estes Termos de Uso.</strong>
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="termos-footer">
        <div className="termos-footer-content">
          <p>&copy; 2026 ContratoSeguro. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default TermosDeUso;
